export const NAV_ITEM_ICON_SIZE = 'x-small'
export const SUBMENU_MIN_WIDTH = '200px'
export const SUBMENU_MAX_WIDTH = '296PX'
